import { render } from "./ReporteORI.vue?vue&type=template&id=369b7a43&scoped=true"
import script from "./ReporteORI.vue?vue&type=script&lang=js"
export * from "./ReporteORI.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./ReporteORI.vue?vue&type=style&index=1&id=369b7a43&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-369b7a43"]])

export default __exports__